import {AppLocale} from '@config/locales';

export const getPrependLocale = (pathname: string, locale: AppLocale) => {
    const pathnameWithoutTrailingSlash = pathname.endsWith('/')
        ? pathname.slice(0, -1)
        : pathname;

    return `/${locale}${pathnameWithoutTrailingSlash}`;
};
